import { useState } from "react";
import { authAPI } from "../api/api";

function SignupModal({ close, openLogin }) {
  const [role, setRole] = useState(""); // partner | customer
  const [form, setForm] = useState({
    businessName: "",
    ownerName: "",
    fullName: "",
    mobile: "",
    email: "",
    password: ""
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setError(""); // Clear error on input change
  };

  const handleRegister = async () => {
    if (!role) {
      setError("Please select Partner or Customer");
      return;
    }

    // Validation
    if (!form.email || !form.mobile || !form.password) {
      setError("Please fill all required fields");
      return;
    }

    if (role === "partner" && (!form.businessName || !form.ownerName)) {
      setError("Please fill all required fields");
      return;
    }

    if (role === "customer" && !form.fullName) {
      setError("Please fill all required fields");
      return;
    }

    setLoading(true);
    setError("");

    try {
      let response;
      if (role === "partner") {
        response = await authAPI.signupPartner(
          form.businessName,
          form.ownerName,
          form.email,
          form.mobile,
          form.password
        );
      } else {
        response = await authAPI.signupCustomer(
          form.fullName,
          form.email,
          form.mobile,
          form.password
        );
      }

      if (response.success) {
        // Store token and user data
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("user", JSON.stringify(response.data));
        
        alert(`✅ ${response.message}`);
        close();
        window.location.reload(); // Refresh to update UI
      }
    } catch (err) {
      setError(err.message || "Registration failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-wrapper">
      <div className="modal-box">
        <span className="close-btn" onClick={close}>✖</span>

        <h2>Sign Up</h2>

        {error && <p style={{ color: 'red', fontSize: '14px' }}>{error}</p>}

        {/* ROLE SELECTION */}
        <div className="role-box">
          <div
            className={`role-card ${role === "partner" ? "active" : ""}`}
            onClick={() => setRole("partner")}
          >
            Partner
          </div>

          <div
            className={`role-card ${role === "customer" ? "active" : ""}`}
            onClick={() => setRole("customer")}
          >
            Customer
          </div>
        </div>

        {/* PARTNER FIELDS */}
        {role === "partner" && (
          <>
            <input
              name="businessName"
              placeholder="Business Name *"
              value={form.businessName}
              onChange={handleChange}
            />
            <input
              name="ownerName"
              placeholder="Owner Name *"
              value={form.ownerName}
              onChange={handleChange}
            />
          </>
        )}

        {/* CUSTOMER FIELDS */}
        {role === "customer" && (
          <>
            <input
              name="fullName"
              placeholder="Full Name *"
              value={form.fullName}
              onChange={handleChange}
            />
  
          </>
        )}

        {/* COMMON FIELDS */}
        {role && (
          <>
            <input
              name="mobile"
              placeholder="Mobile Number *"
              value={form.mobile}
              onChange={handleChange}
            />
            <input
              name="email"
              type="email"
              placeholder="Email *"
              value={form.email}
              onChange={handleChange}
            />
            <input
              name="password"
              type="password"
              placeholder="Password *"
              value={form.password}
              onChange={handleChange}
            />

            <button 
              className="top-btn full" 
              onClick={handleRegister}
              disabled={loading}
            >
              {loading ? "Registering..." : `Register as ${role}`}
            </button>
          </>
        )}

        <p className="switch">
          Already have an account?
          <span onClick={openLogin}> Login</span>
        </p>
      </div>
    </div>
  );
}

export default SignupModal;
